import React, { useState, useEffect } from "react";
import {
  Collapse, Empty, Radio, Spin,
} from "antd";
import { toast } from "react-toastify";
import { isEmpty } from "lodash";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { fetchCocCustomerById } from "../../../actions/dashboard";
import SamplesPreview from "./SamplesPreview";

import "./Coc.css";

export default function Coc({
  customerId, dateRange, searchParams, filterRetest,
}) {
  const [cocs, setCocs] = useState({});
  const [clickedCoc, setClickedCoc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [collapseKey, setCollapseKey] = useState(uuidv4());
  const [woStatus, setWoStatus] = useState("false");
  const [, setApiController] = useState(null);
  const [isMounted, setIsMounted] = useState(true); // Track mounted state

  const abortPrevApiCall = (controller) => {
    setApiController((prevController) => {
      if (prevController) prevController.abort();
      return controller;
    });
  };

  const fetchCocData = async (payload) => {
    setLoading(true);
    const controller = new AbortController();
    abortPrevApiCall(controller);
    const {
      success, result, message, canceled,
    } = await fetchCocCustomerById(payload, controller.signal);
    if (!isMounted) return;
    if (success) {
      if (!isEmpty(result)) {
        setCocs(result);
        setCollapseKey(uuidv4()); // update the Collapse component key here to force it rerender
      } else {
        setCocs({});
      }
    } else if (!canceled) {
      toast.error(message);
      setCocs({});
    }
    setLoading(canceled === undefined ? false : canceled);
  };

  /**
   * This useEffect is used to track the component's unmount event
   */
  useEffect(() => () => {
    setIsMounted(false); // Component is unmounted, set isMounted to false
  }, []); // eslint-disable-line

  /**
   * This fetch the latest COC data when customer id or date range on changes or search value changes
   */
  useEffect(() => {
    if (!customerId) return;
    const payload = {
      customer_id: customerId, date_range: dateRange, retest: filterRetest, wo_status: woStatus,
    };
    if (searchParams.value && searchParams.value !== "") {
      payload[searchParams.paramName] = searchParams.value;
    }
    fetchCocData(payload);
  }, [customerId, dateRange, searchParams, filterRetest, woStatus]); // eslint-disable-line 

  const handleCocItemClick = (record) => {
    setClickedCoc(record);
  };

  const renderItems = (data) => Object.keys(data).map((date, dateIndex) => ({
    key: (dateIndex + 1).toString(),
    label: (
      <div className="COCCard__Header">
        <p>
          <span className="COCCard--title">Created: </span>
          {date}
        </p>
      </div>
    ),
    children: (
      <div className="COCCard__BodyContainer">
        {data[date].map((coc) => {
          const formattedValue = decodeURI(coc.coc_file).split("coc_files/")[1];
          return (
            <div className="COCCard__Body" key={coc.id} onClick={() => handleCocItemClick(coc)}>
              <p>
                <span className="COCCard--title">Received: </span>
                {moment(coc.recieved_at).format("MM/DD/YYYY")}
              </p>
              <p>{formattedValue}</p>
            </div>
          );
        })}
      </div>
    ),
  }));

  const renderCocs = (data) => {
    if (!isEmpty(data)) {
      return (
        <Collapse key={collapseKey} items={renderItems(data)} expandIconPosition="start" />
      );
    }
    return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />;
  };

  return (
    <Spin spinning={loading} size="large">
      <div className="wo_status_filter">
        <div className="wo_status_filter__title">WO Generated</div>
        <Radio.Group value={woStatus} onChange={(event) => setWoStatus(event.target.value)}>
          <Radio value="false">No</Radio>
          <Radio value="true">Yes</Radio>
        </Radio.Group>
      </div>
      <div className="Dashboard__Coc">
        {renderCocs(cocs)}
        {clickedCoc && (<SamplesPreview modalData={{ type: "coc", ...clickedCoc }} closeModal={() => setClickedCoc(null)} />)}
      </div>
    </Spin>
  );
}
